import React from 'react';
import Item from './Item';
import styles from "./plans.module.scss";


export function PlansRadio(props) {
  const { plans, onChange } = props;
  return (
    <div className={styles['container']}>
      {plans && plans.length ? (
        <h2 className={styles['section-title']}>Select installments plan</h2>
      ) : (
        ''
      )}
      <form className={styles['radio-form']}>
        {plans && plans.map((item) => {
          return <Item key={item.month} data={item} handleClick={onChange} />;
        })}
      </form>
    </div>
  );
}

export default PlansRadio;
